import { IMultiSelectComboBoxOption } from 'components/atoms/MultiSelectComboBox/MultiSelectComboBox';
import {
	IBranchesTotalByType,
	IStatus as BranchIStatus,
	ITotalByType,
	IMonth,
} from './Branches';

import { IGetUser } from './User';

export type IncidentPdfTypes = 'full' | 'redacted';

export type IQueryPeriod = 'today' | 'week' | 'month' | 'all';
export type IQueryReportSection =
	| 'section1'
	| 'section2'
	| 'section3'
	| 'section4'
	| 'section5'
	| 'section6'
	| 'section7';

export interface ITabState {
	section1: boolean;
	section2: boolean;
	section3: boolean;
	section4: boolean;
	section5: boolean;
	section6: boolean;
	section7: boolean;
}
export interface IVehicleIncident {
	id: number;
	uid: string;
	alloc8_id: string;
	type: 'incident';
	submitted_at: string;
	createdAt: string;
	updatedAt: string;
	status: 'new' | 'open' | 'closed' | 'draft';
	severity: 'normal' | 'high';
	special_status: 'duplicate' | 'nuisance' | null;
	ticket_number: string;
	description: string;
	submitted_by: string;
	completed: boolean;
	incident_section_1: {
		incident_date: Date;
		id: number;
	};
	incident_section_2: {
		id: number;
		personInvolved: {
			id: string;
			personInvolved_name: string;
		}[];
	};
	incident_section_3: {
		id: number;
		nuisance_report: boolean;
	};
	incident_section_4: {
		id: number;
		incident_category: { id: number; label: string }[];
		mvi_causation: { id: number; label: string }[];
		life_saving_rule_breach?: boolean;
		life_saving_rules?: { id: number; label: string }[];
		severity_rating?: string;
	};
	incident_section_5: {
		id: number;
		incident_investigation_required: boolean;
	};
	incident_section_6: {
		id: number;
	};
	incident_section_7: {
		id: number;
		actions?: {
			id: number;
			assignee?:
				| number
				| {
						id: number;
						first_name: string;
						last_name: string;
				  };
		}[];
	};
	client: string;
	branch: {
		id: string;
		name: string;
	};
	incidents: {
		question: string;
		answer: string;
	}[];
	managers: {
		id: string;
		first_name: string;
		last_name: string;
	}[];
	assignees: {
		id: string;
		first_name: string;
		last_name: string;
	}[];
	incident_activities: {
		createdAt: string;
		name: string;
		type: string;
	};
}

export interface ISortIncidentData {
	branch: IOption[];
	client: IOption[];
	severity: IOption[];
	status: IOption[];
	state: IOption[];
	assignee: IOption[];
	involved: IOption[];
}

export interface IIncident {
	incidentData: {
		id: number;
		alloc8_id: string;
		submitted_at: string;
		createdAt: string;
		updatedAt: string;
		status: 'new' | 'open' | 'closed' | 'draft';
		severity: 'normal' | 'high';
		ticket_number: string;
		description: string;
		submitted_by: string;
		completed: boolean;
		client: string;
		incident_section_1: IVehicleIncidentSection1Payload;
		incident_section_2: IVehicleIncidentSection2;
		incident_section_3: IVehicleIncidentSection3Payload;
		incident_section_4: IVehicleIncidentSection4Payload;
		incident_section_5: IVehicleIncidentSection5Payload;
		incident_section_6: IVehicleIncidentSection6Payload;
		incident_section_7: IVehicleIncidentSection7Payload;
	};
}

export interface ISections {
	incident_section_1: number | null;
	incident_section_2: number | null;
	incident_section_3: number | null;
	incident_section_4: number | null;
	incident_section_5: number | null;
}

export interface IVehicleCreateIncident {
	id: number;
	alloc8_id: null;
	client: null;
	description: null;
	severity: string;
	status: string;
	submitted_by: null;
	ticket_number: null;
	branch: number | null;
}

export interface IVehicleIncidentUpdate {
	id: number;
	branch: number | null;
	ticket_number: string;
	client_name: string;
	description: string;
}

export interface IVehicleIncidentSection1Payload {
	id: number | null;
	incidentId: number | null;
	createdAt?: string;
	incident_date: string | undefined;
	branch: string;
	reported_date: string;
	location: string;
	incident_time: string;
	reported_time: string;
	incident_description: string;
	client_name: string;
	job_details: string;
	mv_incident: boolean;
	altusRegistration: string;
	driverName: string;
	licenseClass: string;
	licenseExpiry: string;
	updatedAt?: string;
	branch_id?: string;
	thirdParty: boolean;
	thirdParties?: {
		id: number;
		thirdParty_name: string;
		thirdParty_vehicle_registration: string;
		thirdParty_licence_number: string;
		thirdParty_phone_number: string;
	}[];
	actionTaken: string;
	emergencyResponseAttendance: {
		id: number;
		title: string;
		checked: boolean;
	}[];
	emergencyResponseAttendanceOther: string;
	trafficControllersIntervened: boolean;
	workCeasedUnsafeConditions: boolean;
}

export interface IVehicleIncidentSection1 {
	description: string;
	location: string;
	client: string;
	jobDetails: string;
	altusRegistration: string;
	driverName: string;
	licenseClass: string;
	licenseExpiry: string;
	incident_date: Date | undefined;
	reported_date: Date;
	reported_time: string;
	branch: string;
	incident_time: string;
	mv_incident: boolean;
	thirdParty: boolean;
	thirdParties?: {
		id: number;
		thirdParty_name: string;
		thirdParty_vehicle_registration: string;
		thirdParty_licence_number: string;
		thirdParty_phone_number: string;
	}[];
	actionTaken: string;
	emergencyResponseAttendance: IOption[];
	emergencyResponseAttendanceOther: string;
	trafficControllersIntervened: boolean;
	workCeasedUnsafeConditions: boolean;
}

export interface IVehicleCreateIncidentSection1 {
	id: number;
	client_name: string;
	incident_date: string;
	incident_description: string;
	incident_time: string;
	job_details: string;
	location: string;
	mv_incident: boolean;
	branch: string;
	reported_date: string;
	altusRegistration: string;
	driverName: string;
	licenseClass: string;
	licenseExpiry: string;
	thirdParty: boolean;
	thirdParties?: {
		id: number;
		thirdParty_name: string;
		thirdParty_vehicle_registration: string;
		thirdParty_licence_number: string;
		thirdParty_phone_number: string;
	}[];
	actionTaken: string;
	emergencyResponseAttendance?: IOption[];
	emergencyResponseAttendanceOther?: string;
}

export interface IVehicleCreateIncidentSection3 {
	id: number;
	name: string;
	body_injured_other_description: null;
	incident_agency_other_description: null;
	incident_mechanism_other_description: null;
	injury_type_other_description: null;
	position: null;
	injuries: boolean;
	restricted_injury: boolean;
}

export interface IVehicleCreateIncidentSection3Payload {
	id: number;
	body_injured: {
		label: string;
		name: string;
		is_selected: boolean;
		description: string;
	}[];
	injury_type: {
		label: string;
		name: string;
		is_selected: boolean;
		description: string;
	}[];
	incident_mechanism: {
		label: string;
		name: string;
		is_selected: boolean;
		description: string;
	}[];
	incident_agency: {
		label: string;
		name: string;
		is_selected: boolean;
		description: string;
	}[];
}
export interface IVehicleCreateIncidentSection4 {
	id: number;
	name: string;
	reported_to: string;
	reference_number: string;
	notes: string;
	severity_rating: string;
	notifiable_incident: boolean;
	code_of_conduct_breach: boolean;
}

export interface IVehicleCreateIncidentSection4Payload {
	id: number;
	incident_category: {
		label: string;
		name: string;
		is_selected: boolean;
		description: string;
	}[];
	life_saving_rules: {
		label: string;
		name: string;
		is_selected: boolean;
		description: string;
	}[];
	code_of_conduct: {
		label: string;
		name: string;
		is_selected: boolean;
		description: string;
	}[];
}

export interface IVehicleCreateIncidentSection5 {
	id: number;
	name: string;
	absent_failed_defense: string;
	action_description: string;
	action_taken: string;
	individual_factors: string;
	organisational_factors: string;
	task_environmental_factors: string;
	percentage_of_shift_worked: string;
	portion_of_shift_worked: string;
	shift_start_time: string;
	completed: boolean;
	incident_investigation_required: boolean;
}

export interface IVehicleCreateIncidentSection5Payload {
	id: number;
}

export interface IVehicleCreateIncidentSection7 {
	id: number;
	name: string;
}

export interface IVehicleCreateIncidentSection7Payload {
	id: number;
}

export interface IVehicleIncidentSection2Payload {
	id: number;
	createdAt?: string;
	personInvolved: {
		id: number;
		personInvolved_name: string;
		personInvolved_phone_number: string;
		personInvolved_start_date: string | undefined;
		personInvolved_task: string;
	}[];
	witness_exists: boolean;
	witnesses: {
		id: number;
		witness_name: string;
		witness_position: string;
		witness_task: string;
		witness_phone_number: string;
	}[];
}

export interface IVehicleIncidentSection2 {
	id: number | null;
	personInvolved: {
		id: number;
		personInvolved_name: string;
		personInvolved_start_date: Date | undefined;
		personInvolved_phone_number: string;
		personInvolved_length_of_service?: string;
		personInvolved_task: string;
	}[];
	witness_exists: boolean;
	witnesses: {
		id: number;
		witness_name: string;
		witness_position: string;
		witness_task: string;
		witness_phone_number: string;
	}[];
}

export interface IVehicleIncidentSection3 {
	bodyParts: IOption[];
	bodyPartsInjured: IOption[];
	bodyPartsInjuredOtherInput: string;
	injuryType: IOption[];
	injuryTypeOtherInput: string;
	incidentMechanism: IOption[];
	incidentMechanismOtherInput: string;
	incidentAgency: IOption[];
	mviCausation: IOption[];
	incidentAgencyOtherInput: string;
	injuries: boolean;
	restricted_injury: boolean;
}

export interface IVehicleIncidentSection3Payload {
	id: number;
	injury_type_other_description: string;
	incident_mechanism_other_description: string;
	incident_agency_other_description: string;
	body_injured_other_description: string;
	injuries: boolean;
	restricted_injury: boolean;
	body_injured: {
		id: number;
		title: string;
		checked: boolean;
	}[];
	injury_type: {
		id: number;
		title: string;
		checked: boolean;
	}[];
	incident_mechanism: {
		id: number;
		title: string;
		checked: boolean;
	}[];
	incident_agency: {
		id: number;
		title: string;
		checked: boolean;
	}[];
}

export interface IVehicleIncidentSection4 {
	severityRating: string;
	reportedTo: string;
	referenceNumber: string;
	notes: string;
	isNotifiableIncident: boolean;
	isLifeSavingBreach: boolean;
	isEmployeeTermination: boolean;
	isCodeOfConductBreach: boolean;
	incidentCategory: {
		id: number;
		title: string;
		checked: boolean;
		description: string;
	}[];
	incidentMechanism: IOption[];
	incidentMechanismOtherInput: string;
	incidentAgency: IOption[];
	incidentAgencyOtherInput: string;
	psychosocialAgency: IOption[];
	lifeSavingRules: {
		id: number;
		title: string;
		checked: boolean;
		description: string;
	}[];
	mviCausation: {
		id: number;
		title: string;
		checked: boolean;
		description?: string;
	}[];
	codeOfConduct: {
		id: number;
		title: string;
		checked: boolean;
	}[];
}
export interface IVehicleIncidentSection4Payload {
	id: number;
	severity_rating: string;
	reported_to: string;
	reference_number: string;
	notes: string;
	coaching_evidence_file?: {
		id: number;
		name: string;
	} | null;
	notifiable_incident: boolean;
	life_saving_rule_breach: boolean;
	employee_termination?: boolean;
	code_of_conduct_breach: boolean;
	incident_category: {
		id: number;
		title: string;
		checked: boolean;
		description: string;
	}[];
	incident_mechanism: {
		id: number;
		title: string;
		checked: boolean;
	}[];
	incident_agency: {
		id: number;
		title: string;
		checked: boolean;
	}[];
	psychosocial_agency: IOption[];
	mvi_causation: {
		id: number;
		title: string;
		checked: boolean;
	}[];
	incident_mechanism_other_description: string;
	incident_agency_other_description: string;
	life_saving_rules: {
		id: number;
		title: string;
		checked: boolean;
		description: string;
	}[];
	code_of_conduct: {
		id: number;
		title: string;
		checked: boolean;
	}[];
}

export interface IVehicleIncidentSection5 {
	id: number;
	section1Id: number | null;
	incidentReportId: number | null;
	name?: string;
	createdAt?: string;
	updatedAt?: string;
	shift_start_time: string;
	incident_investigation_required: boolean;
	organisational_factors?: string;
	task_environmental_factors?: string;
	individual_factors?: string;
	absent_failed_defense?: string;
	percentage_of_shift_worked: string;
	isReportFinished?: boolean;
	investigator: string;
	users: IMultiSelectComboBoxOption[] | { id: string; label: string }[];
	attachments: File[];
}

export interface IVehicleIncidentSection5Payload {
	id: number | null;
	name?: string;
	createdAt?: string;
	updatedAt?: string;
	shift_start_time: string;
	incident_investigation_required: boolean;
	organisational_factors?: string;
	task_environmental_factors?: string;
	individual_factors?: string;
	absent_failed_defense?: string;
	percentage_of_shift_worked: string;
	isReportFinished?: boolean;
	assignees: IGetUser[];
	investigator: {
		first_name: string;
		last_name: string;
	};
	users: IMultiSelectComboBoxOption[] | { id: string; label: string }[];
	section1Id: number | null;
	incidentReportId: number | null;
	attachments: File[];
}

export interface IVehicleIncidentSection6Event {
	id: number;
	date: Date;
	time: string;
	eventDescription: string;
	isCritical: boolean;
}

export interface IVehicleIncidentSection6 {
	id: number | null;
	events: IVehicleIncidentSection6Event[];
	peepoPeopleTeamFactors: string;
	peepoEnvironment: string;
	peepoEquipment: string;
	peepoProcedures: string;
	peepoOrganisation: string;
	findingsCriticalControlFailures: string;
	findingsSignificantLearnings: string;
	findingsAdditionalFindings: string;
}

export interface IIcamEvent {
	id: number;
	date: Date;
	time: string;
	eventDescription: string;
	isCritical: boolean;
}

export interface IVehicleIncidentSection6Payload {
	id: number | null;
	events: IIcamEvent[];
	peepoPeopleTeamFactors: string;
	peepoEnvironment: string;
	peepoEquipment: string;
	peepoProcedures: string;
	peepoOrganisation: string;
	findingsCriticalControlFailures: string;
	findingsSignificantLearnings: string;
	findingsAdditionalFindings: string;
}

export interface IVehicleIncidentSection7 {
	id: number | null;
	users: IMultiSelectComboBoxOption[] | { id: string; label: string }[];
	incidentReportId: number | null;
	section1Id: number | null;
	actions: {
		id?: number;
		action_description: string;
		hierachy_of_control: {
			id?: number;
			label: string;
			name: string;
			is_selected: boolean;
		}[];
		assignee?:
			| number
			| {
					id: number;
					first_name: string;
					last_name: string;
			  };
		action_taken: string;
		completion_date: Date | string;
		completed: boolean;
		priority: string;
	}[];
	isReportCompleted?: boolean;
}

export interface IVehicleIncidentSection7Payload {
	id: number | null;
	users: IMultiSelectComboBoxOption[] | { id: string; label: string }[];
	incidentReportId: number | null;
	section1Id: number | null;
	actions: {
		id: number;
		action_description: string;
		hierachy_of_control: {
			id?: number;
			label: string;
			name: string;
			is_selected: boolean;
		}[];
		assignee?: IGetUser;
		action_taken: string;
		completion_date: Date;
		completed: boolean;
	}[];
	isReportCompleted?: boolean;
}

export interface ISection1ErrorStates {
	section_1_incident_description: boolean;
	section_1_location: boolean;
	section_1_client_name: boolean;
	section_1_job_details: boolean;
	section_1_incident_date: boolean;
	section_1_reported_date: boolean;
	section_1_incident_time: boolean;
	section_1_reported_time: boolean;
}

export interface ISection2ErrorStates {}

export interface ISection3ErrorStates {
	section_3_body_parts: boolean;
	section_3_injury_type: boolean;
	section_3_incident_mechanism: boolean;
	section_3_incident_agency: boolean;
}

export interface ISection4ErrorStates {
	section_4_incident_category: boolean;
	section_4_reported_to: boolean;
	section_4_reference_number: boolean;
	section_4_life_saving_rules: boolean;
	section_4_code_of_conduct_checkbox: boolean;
	section_4_incident_mechanism: boolean;
	section_4_incident_agency: boolean;
}

export interface ISection5ErrorStates {
	section_5_shift_start_time: boolean;
	section_5_investigator: boolean;
}

export interface ISection7ErrorStates {
	section_7_hierachy_control: boolean;
	section_7_action_input: boolean;
	section_7_assigned_to: boolean;
}

export type ISection1Type =
	| 'description'
	| 'location'
	| 'client'
	| 'incident_time'
	| 'jobDetails'
	| 'altusRegistration'
	| 'driverName'
	| 'licenseClass'
	| 'incident_date'
	| 'reported_date'
	| 'licenseExpiry'
	| 'branch'
	| 'thirdParty_name'
	| 'thirdParty_vehicle_registration'
	| 'thirdParty_licence_number'
	| 'thirdParty_phone_number'
	| 'actionTaken'
	| 'reported_time'
	| 'emergencyResponseAttendance'
	| 'emergencyResponseAttendanceOther';

export type ISection2Type =
	| 'personInvolved_name'
	| 'personInvolved_start_date'
	| 'personInvolved_phone_number'
	| 'personInvolved_task'
	| 'witness_name'
	| 'witness_phone_number'
	| 'witness_position'
	| 'witness_task';

export type ISection5Type =
	| 'percentageShiftWorked'
	| 'shiftStartTime'
	| 'organisationalFactorsInput'
	| 'organisationalFactors2Input'
	| 'individualFactorsInput'
	| 'absentDefenseInput'
	| 'investigator'
	| 'users'
	| 'attachments'
	| 'actions';

export interface IFilters {
	[name: string]: IOption[] | string | null;
}
export interface IOption {
	id: number;
	title: string;
	checked: boolean;
}

const branch = [{ id: 1, title: '', checked: false }];

const severity = [
	{ id: 1, title: 'Level 1', checked: false },
	{ id: 2, title: 'Level 2', checked: false },
	{ id: 3, title: 'Level 3', checked: false },
	{ id: 4, title: 'Level 4', checked: false },
	{ id: 5, title: 'Level 5', checked: false },
];

const status = [
	{
		id: 1,
		title: 'new',
		checked: false,
	},
	{
		id: 2,
		title: 'open',
		checked: false,
	},
	{
		id: 3,
		title: 'closed',
		checked: false,
	},
	{
		id: 4,
		title: 'draft',
		checked: false,
	},
	{
		id: 5,
		title: 'nuisance',
		checked: false,
	},
	{
		id: 6,
		title: 'duplicate',
		checked: false,
	},
];

const incidentCategory = [
	{
		id: 1,
		title: 'Lost Time Injury (LTI)',
		checked: false,
	},
	{
		id: 2,
		title: 'Medical Treatment Injury (MTI)',
		checked: false,
	},
	{
		id: 3,
		title: 'First Aid Injury (FAI)',
		checked: false,
	},
	{
		id: 4,
		title: 'No Treatment Injury (NOT)',
		checked: false,
	},
	{
		id: 5,
		title: 'Non-Compliance (NC)',
		checked: false,
	},
	{
		id: 6,
		title: 'Plant & Equipment Incident (PE)',
		checked: false,
	},
	{
		id: 7,
		title: 'Motor Vehicle Incident (MVI)',
		checked: false,
	},
	{
		id: 18,
		title: 'Motor Vehicle Incident (MVI2)',
		checked: false,
	},
	{
		id: 8,
		title: 'Motor Vehicle Incident (MVI3)',
		checked: false,
	},
	{
		id: 9,
		title: 'Motor Vehicle Incident (MVI4)',
		checked: false,
	},
	{
		id: 10,
		title: 'Property Incident (PI)',
		checked: false,
	},
	{
		id: 11,
		title: 'Environment Incident (ENV)',
		checked: false,
	},
	{
		id: 12,
		title: 'Near Miss Incident (NMI)',
		checked: false,
	},
	{
		id: 13,
		title: 'Client Complaint (CC)',
		checked: false,
	},
	{
		id: 14,
		title: 'Public Complaint (PC)',
		checked: false,
	},
	{
		id: 15,
		title: 'Internal Complaint (IC)',
		checked: false,
	},
	{
		id: 16,
		title: 'Third Party behaviour (TPB)',
		checked: false,
	},
	{
		id: 17,
		title: 'Other (OTH)',
		checked: false,
	},
	{
		id: 19,
		title: 'Non Work Related',
		checked: false,
	},
];

const lifeSavingRules = [
	{ id: 1, title: 'Drug and Alcohol Free Workplace', checked: false },
	{ id: 2, title: 'Safe Driving', checked: false },
	{ id: 3, title: 'Exclusion Zones', checked: false },
	{ id: 4, title: 'Mobile Phones', checked: false },
	{ id: 5, title: 'Working In and Around Live Traffic', checked: false },
	{ id: 6, title: 'Safety Controls', checked: false },
];

// Titles must match the Strapi psychosocial_agency labels exactly.
const psychosocialAgency = [
	'Bullying',
	'Conflict / Poor Workplace Relationships and Interactions',
	'Fatigue',
	'Harassment (including sexual and gender based harassment)',
	'Inadequate Reward & Recognition',
	'Intrusive Surveillance',
	'Job Demands (High or Low)',
	'Job Insecurity',
	'Lack Of Role Clarity',
	'Low Job Control',
	'Poor Organisational Change Management',
	'Poor Organisational Justice',
	'Poor Physical Environment',
	'Poor Support',
	'Remote Or Isolated Work',
	'Traumatic Events or Material',
	'Violence & Aggression',
].map((title, index) => ({ id: index + 1, title, checked: false }));

const codeOfConduct = [
	{ id: 1, title: 'Personal Conduct', checked: false },
	{ id: 2, title: 'Respect for Others', checked: false },
	{ id: 3, title: 'Community and Environment', checked: false },
	{ id: 4, title: 'Standard of Dress & Appearance', checked: false },
	{ id: 5, title: 'Attendance and Availability', checked: false },
	{ id: 6, title: 'Conflict of Interest', checked: false },
];

const restrictedInjury = [
	{ id: 1, title: 'Yes', checked: false },
	{ id: 2, title: 'No', checked: false },
];

const workCeasedUnsafeConditions = [
	{ id: 1, title: 'Yes', checked: false },
	{ id: 2, title: 'No', checked: false },
];

const trafficControllersIntervened = [
	{ id: 1, title: 'Yes', checked: false },
	{ id: 2, title: 'No', checked: false },
];

const mviCausation = [
	{ id: 1, title: 'Animal Strike', checked: false, description: '' },
	{ id: 2, title: 'Bogged', checked: false, description: '' },
	{ id: 3, title: 'Nose to Tail', checked: false, description: '' },
	{ id: 4, title: 'Projectile', checked: false, description: '' },
	{ id: 5, title: 'Reversing', checked: false, description: '' },
	{ id: 6, title: 'Side Swipe', checked: false, description: '' },
	{ id: 7, title: 'Struck Object', checked: false, description: '' },
	{
		id: 8,
		title: 'Struck Overhead Structure',
		checked: false,
		description: '',
	},
	{ id: 9, title: 'Tree/Branch', checked: false, description: '' },
];

export interface IOption {
	id: number;
	title: string;
	checked: boolean;
	description?: string;
}

export const section4RadioButtons = [
	{
		id: '1',
		title: 'Level 1',
		subTitle: '(Low)',
		description: 'Minor Incident or Near Miss (NOT)',
	},
	{
		id: '2',
		title: 'Level 2',
		subTitle: '(Medium)',
		description: 'Moderate incident or Near Miss (FAI)',
	},
	{
		id: '3',
		title: 'Level 3',
		subTitle: 'High',
		description: 'Serious Incident or Near Miss, (MTI) - (LSR)',
	},
	{
		id: '4',
		title: 'Level 4',
		subTitle: '(Severe)',
		description: 'Significant Incident or Near Miss - (LTI)',
	},
	{
		id: '5',
		title: 'Level 5',
		subTitle: '(Extreme)',
		description: 'Catastrophic Incident (Fatality)',
	},
];

export const section7PriorityRadioButtons = [
	{
		id: '1',
		title: 'Low',
	},
	{
		id: '2',
		title: 'Medium',
	},
	{
		id: '3',
		title: 'High',
	},
	{
		id: '4',
		title: 'Critical',
	},
];

export const section5PercentageRadioButtons = [
	{
		id: '1',
		title: 'N/A',
	},
	{
		id: '2',
		title: '0% - 10%',
	},
	{
		id: '3',
		title: '11% - 50%',
	},
	{
		id: '4',
		title: '51% - 80%',
	},
	{
		id: '5',
		title: '81% - 100%',
	},
	{
		id: '6',
		title: '100% +',
	},
];

export const section5PortionRadioButtons = [
	{
		id: '1',
		title: 'Immediate',
	},
	{
		id: '2',
		title: 'Medium',
	},
	{
		id: '3',
		title: 'Long',
	},
];

//Keeping all this data for now to transfer to JSON when we need to create reports in future ticket
export const bodyParts = [
	{ id: 1, title: 'Left', checked: false },
	{ id: 2, title: 'First Right', checked: false },
	{ id: 3, title: 'Upper', checked: false },
	{ id: 4, title: 'Lower', checked: false },
];

export const bodyPartsInjured = [
	{ id: 5, title: 'Finger', checked: false },
	{ id: 6, title: 'Arm', checked: false },
	{ id: 7, title: 'Neck', checked: false },
	{ id: 8, title: 'Nose', checked: false },
	{ id: 9, title: 'Jaw', checked: false },
	{ id: 10, title: 'Hip', checked: false },
	{ id: 11, title: 'Foot', checked: false },
	{ id: 12, title: 'Hand', checked: false },
	{ id: 13, title: 'Elbow', checked: false },
	{ id: 14, title: 'Forearm', checked: false },
	{ id: 15, title: 'Head', checked: false },
	{ id: 16, title: 'Ear', checked: false },
	{ id: 17, title: 'Collar', checked: false },
	{ id: 18, title: 'Rib', checked: false },
	{ id: 19, title: 'Mouth/Teeth', checked: false },
	{ id: 20, title: 'Leg', checked: false },
	{ id: 21, title: 'Knee', checked: false },
	{ id: 22, title: 'Shin', checked: false },
	{ id: 23, title: 'Calf', checked: false },
	{ id: 24, title: 'Toe', checked: false },
	{ id: 25, title: 'Wirst', checked: false },
	{ id: 26, title: 'Shoulder', checked: false },
	{ id: 27, title: 'Eye', checked: false },
	{ id: 28, title: 'Back', checked: false },
	{ id: 29, title: 'Psych', checked: false },
	{ id: 30, title: 'Ankle', checked: false },
	{
		id: 31,
		title: 'Internal Organs',
		checked: false,
	},
	{ id: 32, title: 'Other', checked: false },
];

export const injuryType = [
	{
		id: 1,
		title: 'Sprain/Strain',
		checked: false,
	},
	{
		id: 2,
		title: 'Foreign Body',
		checked: false,
	},
	{ id: 3, title: 'Dislocation', checked: false },
	{
		id: 4,
		title: 'Heat Illness',
		checked: false,
	},
	{
		id: 5,
		title: 'Electric Shock',
		checked: false,
	},
	{ id: 6, title: 'Crush', checked: false },
	{
		id: 7,
		title: 'Bruise/Contusion',
		checked: false,
	},
	{
		id: 8,
		title: 'Fracture/Break',
		checked: false,
	},
	{
		id: 9,
		title: 'Consciousness',
		checked: false,
	},
	{
		id: 10,
		title: 'Exposure Substance',
		checked: false,
	},
	{
		id: 11,
		title: 'Cut/Laceration',
		checked: false,
	},
	{ id: 12, title: 'Burn', checked: false },
	{
		id: 13,
		title: 'Inflammation',
		checked: false,
	},
	{ id: 14, title: 'Respiratory', checked: false },
	{ id: 15, title: 'Dermatitis', checked: false },
	{
		id: 16,
		title: 'Allergy/Reaction',
		checked: false,
	},
	{ id: 17, title: 'Stress', checked: false },
	{ id: 18, title: 'Death', checked: false },
	{ id: 19, title: 'Other', checked: false },
];

export const incidentMechanism = [
	{
		id: 1,
		title: 'Absorption/Ingestion or Inhalation',
		checked: false,
	},
	{
		id: 2,
		title: 'Accessing/Egressing',
		checked: false,
	},
	{
		id: 3,
		title: 'Bitten',
		checked: false,
	},
	{
		id: 4,
		title: 'Body Motion or Posture',
		checked: false,
	},
	{
		id: 5,
		title: 'Caught Between',
		checked: false,
	},
	{
		id: 6,
		title: 'Communication',
		checked: false,
	},
	{
		id: 7,
		title: 'Contact With',
		checked: false,
	},
	{
		id: 29,
		title: 'Digi',
		checked: false,
	},
	{
		id: 8,
		title: 'Exposure Substance',
		checked: false,
	},
	{
		id: 9,
		title: 'Exposure to Heat',
		checked: false,
	},
	{
		id: 10,
		title: 'Fall - Different Level Height',
		checked: false,
	},
	{
		id: 11,
		title: 'Falling/Moving Object',
		checked: false,
	},
	{
		id: 12,
		title: 'Fitness for Work',
		checked: false,
	},
	{
		id: 13,
		title: 'Fleet',
		checked: false,
	},
	{
		id: 14,
		title: 'Manual Handling',
		checked: false,
	},
	{
		id: 15,
		title: 'NC Behaviour',
		checked: false,
	},
	{
		id: 16,
		title: 'Physical Altercation',
		checked: false,
	},
	{
		id: 17,
		title: 'Repetitive Motion',
		checked: false,
	},
	{
		id: 18,
		title: 'Scheduling & Planning',
		checked: false,
	},
	{
		id: 19,
		title: 'Slip / Trip / Fall',
		checked: false,
	},
	{
		id: 20,
		title: 'Speeding',
		checked: false,
	},
	{
		id: 21,
		title: 'Struck Against',
		checked: false,
	},
	{
		id: 22,
		title: 'Struck By',
		checked: false,
	},
	{
		id: 23,
		title: 'Theft',
		checked: false,
	},
	{
		id: 24,
		title: 'Using Tools/Equipment',
		checked: false,
	},
	{
		id: 25,
		title: 'Vandalism/Interference',
		checked: false,
	},
	{
		id: 26,
		title: 'Verbal Confrontation',
		checked: false,
	},
	{
		id: 27,
		title: 'Weather',
		checked: false,
	},
	{
		id: 28,
		title: 'Other',
		checked: false,
	},
];

export const incidentAgency = [
	{
		id: 1,
		title: 'Alcohol',
		checked: false,
	},
	{
		id: 2,
		title: 'Animal or Insect',
		checked: false,
	},
	{
		id: 3,
		title: 'Bus',
		checked: false,
	},
	{
		id: 4,
		title: 'Car',
		checked: false,
	},
	{
		id: 5,
		title: 'Chemicals & Substances',
		checked: false,
	},
	{
		id: 6,
		title: 'Cyclist',
		checked: false,
	},
	{
		id: 7,
		title: 'Drugs',
		checked: false,
	},
	{
		id: 8,
		title: 'Drop Deck',
		checked: false,
	},
	{
		id: 9,
		title: 'Dust/Debris',
		checked: false,
	},
	{
		id: 10,
		title: 'Client',
		checked: false,
	},
	{
		id: 11,
		title: 'Emergency Services',
		checked: false,
	},
	{
		id: 12,
		title: 'Employee(s)',
		checked: false,
	},
	{
		id: 13,
		title: 'Ergonomic',
		checked: false,
	},
	{
		id: 14,
		title: 'Fatigue',
		checked: false,
	},
	{
		id: 15,
		title: 'Forklift Trucks / Lifting Devices',
		checked: false,
	},
	{
		id: 16,
		title: 'Loading/Unloading',
		checked: false,
	},
	{
		id: 17,
		title: 'Mobile Phones',
		checked: false,
	},
	{
		id: 18,
		title: 'Mobile Plant',
		checked: false,
	},
	{
		id: 19,
		title: 'MOP',
		checked: false,
	},
	{
		id: 20,
		title: 'Motorbike',
		checked: false,
	},
	{
		id: 21,
		title: 'Noise',
		checked: false,
	},
	{
		id: 22,
		title: 'Plans/Permits',
		checked: false,
	},
	{
		id: 23,
		title: 'Porta-booms',
		checked: false,
	},
	{
		id: 24,
		title: 'Portable Traffic Lights',
		checked: false,
	},
	{
		id: 25,
		title: 'PPE',
		checked: false,
	},
	{
		id: 26,
		title: 'Seatbelt',
		checked: false,
	},
	{
		id: 27,
		title: 'Signs & Signage Equipment',
		checked: false,
	},
	{
		id: 28,
		title: 'Steps or Stairs',
		checked: false,
	},
	{
		id: 29,
		title: 'Stop/Slow - Stop/Go',
		checked: false,
	},
	{
		id: 30,
		title: 'Temperature Extremes/UV',
		checked: false,
	},
	{
		id: 31,
		title: 'TMA',
		checked: false,
	},
	{
		id: 32,
		title: 'Traffic Cones',
		checked: false,
	},
	{
		id: 33,
		title: 'Tools & Equipment',
		checked: false,
	},
	{
		id: 34,
		title: 'Trailer other Vehicle Attachment',
		checked: false,
	},
	{
		id: 35,
		title: 'Truck',
		checked: false,
	},
	{
		id: 36,
		title: 'Uneven/Surfaces',
		checked: false,
	},
	{
		id: 37,
		title: 'Unprotect edges',
		checked: false,
	},
	{
		id: 38,
		title: 'Ute',
		checked: false,
	},
	{
		id: 39,
		title: 'Walkways & Floors',
		checked: false,
	},
	{
		id: 40,
		title: 'Wet/Icy Surfaces',
		checked: false,
	},
	{
		id: 41,
		title: 'Wind/Rain',
		checked: false,
	},
	{
		id: 42,
		title: 'Other',
		checked: false,
	},
];

const bodyInjuredDataBackend = [
	{
		label: 'Left',
		name: 'left',
		is_selected: false,
		description: '',
	},
	{
		label: 'Right',
		name: 'right',
		is_selected: false,
		description: '',
	},
	{
		label: 'Upper',
		name: 'upper',
		is_selected: false,
		description: '',
	},
	{
		label: 'Lower',
		name: 'lower',
		is_selected: false,
		description: '',
	},
	{
		label: 'Finger',
		name: 'finger',
		is_selected: false,
		description: '',
	},
	{
		label: 'Arm',
		name: 'arm',
		is_selected: false,
		description: '',
	},
	{
		label: 'Neck',
		name: 'neck',
		is_selected: false,
		description: '',
	},
	{
		label: 'Nose',
		name: 'nose',
		is_selected: false,
		description: '',
	},
	{
		label: 'Jaw',
		name: 'jaw',
		is_selected: false,
		description: '',
	},
	{
		label: 'Hip',
		name: 'hip',
		is_selected: false,
		description: '',
	},
	{
		label: 'Foot',
		name: 'foot',
		is_selected: false,
		description: '',
	},
	{
		label: 'Hand',
		name: 'hand',
		is_selected: false,
		description: '',
	},
	{
		label: 'Elbow',
		name: 'elbow',
		is_selected: false,
		description: '',
	},
	{
		label: 'Forearm',
		name: 'forearm',
		is_selected: false,
		description: '',
	},
	{
		label: 'Head',
		name: 'head',
		is_selected: false,
		description: '',
	},
	{
		label: 'Ear',
		name: 'ear',
		is_selected: false,
		description: '',
	},
	{
		label: 'Collar',
		name: 'collar',
		is_selected: false,
		description: '',
	},
	{
		label: 'Chest',
		name: 'chest',
		is_selected: false,
		description: '',
	},
	{
		label: 'Rib',
		name: 'rib',
		is_selected: false,
		description: '',
	},
	{
		label: 'Mouth/Teeth',
		name: 'mouth_teeth',
		is_selected: false,
		description: '',
	},
	{
		label: 'Leg',
		name: 'leg',
		is_selected: false,
		description: '',
	},
	{
		label: 'Knee',
		name: 'knee',
		is_selected: false,
		description: '',
	},
	{
		label: 'Shin',
		name: 'shin',
		is_selected: false,
		description: '',
	},
	{
		label: 'Calf',
		name: 'calf',
		is_selected: false,
		description: '',
	},
	{
		label: 'Toe',
		name: 'toe',
		is_selected: false,
		description: '',
	},
	{
		label: 'Wrist',
		name: 'wrist',
		is_selected: false,
		description: '',
	},
	{
		label: 'Shoulder',
		name: 'shoulder',
		is_selected: false,
		description: '',
	},
	{
		label: 'Eye',
		name: 'eye',
		is_selected: false,
		description: '',
	},
	{
		label: 'Back',
		name: 'back',
		is_selected: false,
		description: '',
	},
	{
		label: 'Psych',
		name: 'psych',
		is_selected: false,
		description: '',
	},
	{
		label: 'Ankle',
		name: 'ankle',
		is_selected: false,
		description: '',
	},
	{
		label: 'Internal Organs',
		name: 'internal_organs',
		is_selected: false,
		description: '',
	},
	{
		label: 'Other',
		name: 'other',
		is_selected: false,
		description: '',
	},
];

const bodyInjuredDataRaw = bodyInjuredDataBackend.map((item, index) => {
	return {
		id: index + 1,
		title: item.label,
		checked: false,
	};
});

const bodyPartInjuredArray: IOption[] = [];
const bodyPartInjuredArray2 = [...bodyInjuredDataRaw];
const arrayToFilter = [
	'Left',
	'Right',
	'Upper',
	'Lower',
	'Psych',
	'Internal Organs',
];

for (let i = bodyInjuredDataRaw.length - 1; i >= 0; i--) {
	if (arrayToFilter.includes(bodyInjuredDataRaw[i].title)) {
		bodyPartInjuredArray.push(bodyInjuredDataRaw[i]);
		bodyPartInjuredArray2.splice(i, 1);
	}
}
bodyPartInjuredArray.sort(
	(a, b) => arrayToFilter.indexOf(a.title) - arrayToFilter.indexOf(b.title)
);
bodyPartInjuredArray2.sort((a, b) =>
	a.title === 'Other'
		? 1
		: b.title === 'Other'
			? -1
			: a.title.localeCompare(b.title)
);

bodyPartInjuredArray.push(...bodyPartInjuredArray2);

export const bodyInjuredData = bodyPartInjuredArray;

const injuryTypeDataBackend = [
	{
		label: 'Sprain/Strain',
		name: 'sprain_strain',
		is_selected: false,
		description: '',
	},
	{
		label: 'Foreign Body',
		name: 'foreign_body',
		is_selected: false,
		description: '',
	},
	{
		label: 'Dislocation',
		name: 'dislocation',
		is_selected: false,
		description: '',
	},
	{
		label: 'Heat Illness',
		name: 'heat_illness',
		is_selected: false,
		description: '',
	},
	{
		label: 'Electric Shock',
		name: 'electric_shock',
		is_selected: false,
		description: '',
	},
	{
		label: 'Crush',
		name: 'crush',
		is_selected: false,
		description: '',
	},
	{
		label: 'Bruise/Contusion',
		name: 'bruise_contusion',
		is_selected: false,
		description: '',
	},
	{
		label: 'Fracture/Break',
		name: 'fracture_break',
		is_selected: false,
		description: '',
	},
	{
		label: 'Consciousness',
		name: 'consciousness',
		is_selected: false,
		description: '',
	},
	{
		label: 'Exposure Substance',
		name: 'exposure_substance',
		is_selected: false,
		description: '',
	},
	{
		label: 'Cut/Laceration',
		name: 'cut_laceration',
		is_selected: false,
		description: '',
	},
	{
		label: 'Burn',
		name: 'burn',
		is_selected: false,
		description: '',
	},
	{
		label: 'Inflammation',
		name: 'inflammation',
		is_selected: false,
		description: '',
	},
	{
		label: 'Respiratory',
		name: 'respiratory',
		is_selected: false,
		description: '',
	},
	{
		label: 'Dermatitis',
		name: 'dermatitis',
		is_selected: false,
		description: '',
	},
	{
		label: 'Allergy/Reaction',
		name: 'allergy_reaction',
		is_selected: false,
		description: '',
	},
	{
		label: 'Stress',
		name: 'stress',
		is_selected: false,
		description: '',
	},
	{
		label: 'Death',
		name: 'death',
		is_selected: false,
		description: '',
	},
	{
		label: 'Abrasion/ Graze',
		name: 'abrasion_graze',
		is_selected: false,
		description: '',
	},
	{
		label: 'Other',
		name: 'other',
		is_selected: false,
		description: '',
	},
];

export const injuryTypeData = injuryTypeDataBackend
	.map((item, index) => {
		return {
			id: index + 1,
			title: item.label,
			checked: false,
		};
	})
	.sort((a, b) =>
		a.title === 'Other'
			? 1
			: b.title === 'Other'
				? -1
				: a.title.localeCompare(b.title)
	);

export interface IIncidentCategorySummary {
	id: number;
	name: string;
	statistics: {
		closed: number;
		draft: number;
		open: number;
		submitted: number;
		new: number;
		severities: {
			'Level 1': number;
			'Level 2': number;
			'Level 3': number;
			'Level 4': number;
			'Level 5': number;
		};
		total: number;
		actions: {
			open: number;
			completed: number;
			overdue: number;
			total: number;
		};
	};
}

export interface IIncidentSeveritySummary {
	id: number;
	name: string;
	statistics: {
		closed: number;
		draft: number;
		open: number;
		submitted: number;
		new: number;
		categories: {
			[key: string]: number;
		};
		total: number;
		actions: {
			open: number;
			completed: number;
			overdue: number;
			total: number;
		};
	};
}

export interface IIncidentMechanismSummary {
	id: number;
	name: string;
	statistics: {
		closed: number;
		draft: number;
		open: number;
		submitted: number;
		new: number;
		severities: {
			'Level 1': number;
			'Level 2': number;
			'Level 3': number;
			'Level 4': number;
			'Level 5': number;
		};
		total: number;
		actions: {
			open: number;
			completed: number;
			overdue: number;
			total: number;
		};
	};
}

export interface IIncidentOpenIncidentsSummary {
	id: number;
	name: string;
	statistics: {
		closed: number;
		draft: number;
		open: number;
		submitted: number;
		new: number;
		severities: {
			'Level 1': number;
			'Level 2': number;
			'Level 3': number;
			'Level 4': number;
			'Level 5': number;
		};
		total: number;
		actions: {
			open: number;
			completed: number;
			overdue: number;
			total: number;
		};
		priorities: {
			Low: number;
			Medium: number;
			High: number;
			Critical: number;
		};
	};
}

export interface IIncidentCriticalActionsSummary {
	id: number;
	name: string;
	statistics: {
		closed: number;
		draft: number;
		open: number;
		submitted: number;
		new: number;
		severities: {
			'Level 1': number;
			'Level 2': number;
			'Level 3': number;
			'Level 4': number;
			'Level 5': number;
		};
		total: number;
		actions: {
			open: number;
			completed: number;
			overdue: number;
			total: number;
		};
	};
}

export interface IIncidentAgencySummary {
	id: number;
	name: string;
	statistics: {
		closed: number;
		draft: number;
		open: number;
		submitted: number;
		new: number;
		severities: {
			'Level 1': number;
			'Level 2': number;
			'Level 3': number;
			'Level 4': number;
			'Level 5': number;
		};
		total: number;
		actions: {
			open: number;
			completed: number;
			overdue: number;
			total: number;
		};
	};
}

export interface IGraphCategoryBranch {
	name: string;
	total: number;
	open: number;
	closed: number;
}

export interface IGraphSeverityCategory extends IGraphCategoryBranch {}
export interface IGraphMechanismCategory extends IGraphCategoryBranch {}
export interface IGraphAgencyCategory extends IGraphCategoryBranch {}
export interface IGraphOpenIncidentStatus extends IGraphCategoryBranch {}
export interface IGraphCriticalActionStatus extends IGraphCategoryBranch {}

export interface IGraphCategory {
	name: string;
	total: number;
	open: number;
	closed: number;
	branches: IGraphCategoryBranch[];
}

export interface IGraphSeverity {
	name: string;
	total: number;
	open: number;
	closed: number;
	categories: IGraphSeverityCategory[];
}

export interface IGraphMechanism {
	name: string;
	total: number;
	open: number;
	closed: number;
	categories: IGraphMechanismCategory[];
}

export interface IGraphOpenIncident {
	name: string;
	total: number;
	open: number;
	closed: number;
	statuses: IGraphOpenIncidentStatus[];
}

export interface IGraphCriticalAction {
	name: string;
	total: number;
	open: number;
	closed: number;
	statuses: IGraphCriticalActionStatus[];
}

export interface IGraphAgency {
	name: string;
	total: number;
	open: number;
	closed: number;
	categories: IGraphAgencyCategory[];
}

export interface IIncidentCategoryBreakdown {
	categories: IIncidentCategorySummary[];
	graphCategories: IGraphCategory[];
	total: number;
}

export interface IIncidentSeverityBreakdown {
	severities: IIncidentSeveritySummary[];
	graphSeverities: IGraphSeverity[];
	total: number;
}

export interface IIncidentMechanismBreakdown {
	mechanisms: IIncidentMechanismSummary[];
	graphMechanisms: IGraphMechanism[];
	total: number;
}

export interface IIncidentOpenIncidentsBreakdown {
	openIncidents: IIncidentOpenIncidentsSummary[];
	graphOpenIncidents: IGraphOpenIncident[];
	total: number;
}

export interface IIncidentCriticalActionsBreakdown {
	criticalActions: IIncidentCriticalActionsSummary[];
	graphCriticalActions: IGraphCriticalAction[];
	total: number;
}

export interface IIncidentAgencyBreakdown {
	agencies: IIncidentAgencySummary[];
	graphAgencies: IGraphAgency[];
	total: number;
}

export interface IIncidentCategoryBreakdownFilters {
	branchId?: number;
	dateFrom?: string;
	dateTo?: string;
}

export const emergencyResponseOptions = [
	{
		id: 1,
		title: 'Police',
		checked: false,
	},
	{
		id: 2,
		title: 'Fire Department',
		checked: false,
	},
	{
		id: 3,
		title: 'Ambulance',
		checked: false,
	},
	{
		id: 4,
		title: 'Other',
		checked: false,
	},
];

const correctiveActionsPriority = [
	{
		id: 1,
		title: 'Low',
		checked: false,
	},
	{
		id: 2,
		title: 'Medium',
		checked: false,
	},
	{
		id: 3,
		title: 'High',
		checked: false,
	},
	{
		id: 4,
		title: 'Critical',
		checked: false,
	},
];

const incidentTimeQuadrant = [
	{
		id: 1,
		title: 'Midnight',
		checked: false,
	},
	{
		id: 2,
		title: '0600 - 1200',
		checked: false,
	},
	{
		id: 3,
		title: '1200 - 1800',
		checked: false,
	},
	{
		id: 4,
		title: '1800 - 0000',
		checked: false,
	},
	{
		id: 5,
		title: '0000 - 0600',
		checked: false,
	},
];

const correctiveActions = [
	{
		id: 1,
		title: 'open',
		checked: false,
	},
	{
		id: 2,
		title: 'completed',
		checked: false,
	},
	{
		id: 3,
		title: 'overdue',
		checked: false,
	},
];

const icam = [
	{
		id: 1,
		title: 'ICAM Required',
		checked: false,
	},
];

const notifiableIncident = [
	{
		id: 1,
		title: 'Notifiable Incident',
		checked: false,
	},
];

export const initialFilterState: IFilters = {
	branch,
	severity,
	status,
	to: null,
	from: null,
	keyword: '',
	name: '',
	nameTargets: [
		{ id: 1, title: 'Submitted by', checked: false },
		{ id: 2, title: 'Corrective-action assignee', checked: false },
		{ id: 3, title: 'Incident assignee', checked: false },
	],
	codeOfConduct,
	lifeSavingRules,
	incidentCategory,
	restrictedInjury,
	incidentAgency,
	incidentMechanism,
	psychosocialAgency,
	correctiveActionsPriority,
	incidentTimeQuadrant,
	workCeasedUnsafeConditions,
	trafficControllersIntervened,
	correctiveActions,
	icam,
	notifiableIncident,
	mviCausation,
};

export interface IDashboardOverviewData {
	states: string[];
	branches: IBranchesTotalByType[];
	incidentStatusData: BranchIStatus;
	currentYear: ITotalByType;
	stateTotals: IStatesTotalByType[];
	currentMonthData: IMonth[];
}

export interface IStatesTotalByType extends IBranchesTotalByType {}

export const DashboardFiltersAvailable = [
	'branch',
	'severity',
	'status',
	'to',
	'from',
] as const;

export type DashboardIncidentFilter =
	(typeof DashboardFiltersAvailable)[number];

export interface IDashboardIncidentFiltersPayload {
	branch?: number[];
	severity?: number[];
	status?: string[];
	to?: string | null;
	from?: string | null;
}

export interface IFiltersDashboardIncidents extends IFilters {
	branch: IOption[];
	severity: IOption[];
	status: IOption[];
	to: string | null;
	from: string | null;
	incidentCategory: IOption[];
	incidentAgency: IOption[];
	incidentMechanism: IOption[];
	correctiveActions: IOption[];
	lifeSavingRules: IOption[];
	restrictedInjury: IOption[];
	state: IOption[];
	partOfBody: IOption[];
	injuryType: IOption[];
}

export const InitialDashboardIncidentFilters: IFiltersDashboardIncidents = {
	branch,
	severity,
	status,
	to: null,
	from: null,
	incidentCategory,
	incidentAgency,
	incidentMechanism,
	correctiveActions,
	lifeSavingRules,
	restrictedInjury,
	partOfBody: bodyInjuredData,
	injuryType: injuryTypeData,
	state: [],
};
